import { useEffect } from 'react'
import TopBar from '../../components/general/topbar/TopBar'
import Footer from '../../components/general/footer/Footer'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import ProductosBanner from '../../assets/images/banners/webps/interior2.webp'
import './style.css'
import MMenu from '../../components/specific/m_menu/MMenu'
import { insumosData } from '../../assets/texts/ListaCategoriasInsumos'

export default function Insumos() {

  let navigate = useNavigate()

  useEffect(() => {
    window.scroll(0,0)
  })

  const menu = insumosData.map((item) => {
    return <MMenu text={item.text} title={item.title} image={item.src} imageAlt={item.alt} textButton={"Ver más"} linkButton={item.link}/>
  })

  const metaTags = {
    title: "Repuestos e Insumos",
    description: "Contamos con venta de repuestos e insumos para refrigeracion familiar, comercial y automotriz",
    url: "https://www.nicolinirefrigeracion.com.ar/productos"
  }

  return (
    <div className='Products'>

      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" 
        content={metaTags.description} />
        
        <meta property="og:site_name" content={metaTags.title} />
        <meta property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:image" content={ProductosBanner} />
        <meta property="og:url" content={metaTags.url} />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />
        <meta name="twitter:image" content={ProductosBanner} />
      </Helmet>

      <TopBar />

      <div className='insumosDisplay' >
        
        {menu}
        
      </div>
      <Footer />
    </div>
  )
}
